import { useTheme, styled } from '@mui/material/styles';
import { drawerWidth } from 'store/constant';
import { Drawer, ListItemButton, Paper } from '@mui/material';
import { dark } from '@mui/material/styles/createPalette';

// ==============================|| SIDEBAR DRAWER ||============================== //

const lightGradient = 'linear-gradient(124deg, rgb(0, 150, 136) 25%, rgb(33, 126, 206) 100%)';
const darkGradient = 'linear-gradient(124deg, rgb(9, 48, 44) 25%, rgb(0, 21, 39) 100%)';
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

export const PopoverPaper = styled(Paper)(({ theme }) => ({
  maxWidth: '100%', 
  background: theme.palette.mode === 'light' ? lightGradient : darkGradient,
}));

export const MuiDrawer = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    '& ::-webkit-scrollbar': {
      width: '6px'
    },
  
    '& ::-webkit-scrollbar-track': {
      background: theme.palette.mode === 'light' ? lightGradient : darkGradient,
    },
  
    '& ::-webkit-scrollbar-thumb':{
      background: 'rgba(152, 240, 228, 0.3)',
      borderRadius: '6px'
    },
  
    '& ::-webkit-scrollbar-thumb:hover': {
      background: '#5fa8aa',
    },
    '& .MuiDrawer-paper': {
      marginTop: '110px',
      borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      borderTopRightRadius: 8,
      background: theme.palette.mode === 'light' ? lightGradient : darkGradient,
    },
    variants: [
      {
        props: ({ open }) => open,
        style: {
          ...openedMixin(theme),
          '& .MuiDrawer-paper': openedMixin(theme),
        },
      },
      {
        props: ({ open }) => !open,
        style: {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        },
      },
    ],
  }),
);

export const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1)
}));

export const ListItemButtonWrapper = styled(ListItemButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.mode === 'light' ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)",
    "& .MuiListItemIcon-root": {
      color: "#fff"
    }
  },
  "&.Mui-selected": {
    backgroundColor:  theme.palette.mode === 'light' ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)",
    "& .MuiListItemIcon-root": {
      color: "#fff"
    },
    "&:hover": {
      backgroundColor:  theme.palette.mode === 'light' ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)",
    }
  }
}));

